import { normalizeCommitmentHex } from "./commitment-route.js";

export const STORAGE_KEY = "wen_saved_agents_v1";

/**
 * @typedef {{ commitment_hex: string, label?: string, saved_at: string }} SavedAgent
 */

/**
 * @returns {SavedAgent[]}
 */
export function loadSavedAgents() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (row) =>
        row &&
        typeof row.commitment_hex === "string" &&
        /^[0-9a-f]{64}$/.test(row.commitment_hex)
    );
  } catch {
    return [];
  }
}

/**
 * @param {SavedAgent[]} agents
 */
export function saveSavedAgents(agents) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(agents));
}

/**
 * @param {string} commitmentHex
 * @param {string} [label]
 * @returns {SavedAgent[]}
 */
export function addSavedAgent(commitmentHex, label = "") {
  const hex = normalizeCommitmentHex(commitmentHex);
  const existing = loadSavedAgents().filter((row) => row.commitment_hex !== hex);
  const next = [
    {
      commitment_hex: hex,
      label: label.trim(),
      saved_at: new Date().toISOString(),
    },
    ...existing,
  ];
  saveSavedAgents(next);
  return next;
}

/**
 * @param {string} commitmentHex
 * @returns {SavedAgent[]}
 */
export function removeSavedAgent(commitmentHex) {
  const hex = normalizeCommitmentHex(commitmentHex);
  const next = loadSavedAgents().filter((row) => row.commitment_hex !== hex);
  saveSavedAgents(next);
  return next;
}
